import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ServiceGroup } from '../models/service-group.model';
import { ServiceVenue } from '../models/service-venue.model';
import { sEvent } from '../models/sevent.model';
import { LogService } from './log.service';
import { mEvent } from 'src/app/member/register/mvent.model';
import { xEvent } from '../models/xevent.model';
import { editEvent } from '../models/editEvent.model';
import { DateAvailability } from '../models/date-availability.model';

@Injectable({ providedIn: 'root' })
export class SelectServiceService {
  apiHost: string = environment.apiHost;

  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  getActiveGroups(): Promise<ServiceGroup[]> {
    let promise = new Promise<ServiceGroup[]>((resolve, reject) => {
      return this.http
        .get<ServiceGroup[]>(this.apiHost + '/servicegroup/getallactive')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Select Service: getActiveGroups', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  getActiveVenues(): Promise<ServiceVenue[]> {
    let promise = new Promise<ServiceVenue[]>((resolve, reject) => {
      return this.http
        .get<ServiceVenue[]>(this.apiHost + '/servicevenue/getallactive')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Select Service: getActiveVenues', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  getMyEvents(userId: string, hidden: boolean): Promise<xEvent[]> {
    let promise = new Promise<xEvent[]>((resolve, reject) => {
      return this.http
        .get<xEvent[]>(
          this.apiHost +
            '/event/getmyevents?userId=' +
            userId +
            '&Hidden=' +
            hidden.toString()
        )
        .toPromise()
        .then(
          (data) => {
            data = data.sort((a, b) => {
              if (a.startTime < b.startTime) return -1;
              if (a.startTime > b.startTime) return 1;
              return 0;
            });
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Select Service: getMyEvents', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  releaseEventBlock(eventId: number): Promise<sEvent> {
    let promise = new Promise<sEvent>((resolve, reject) => {
      return this.http
        .post<sEvent>(
          this.apiHost + '/event/ReleaseEventBlock?EventId=' + eventId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Select Service: releaseEventBlock',
                msg
              );
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  cancelEvent(eventId: number, cancellationType: number): Promise<sEvent> {
    let promise = new Promise<sEvent>((resolve, reject) => {
      return this.http
        .post<sEvent>(
          this.apiHost + '/event/CancelEvent?EventId=' + eventId + '&CancellationType=' + cancellationType,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Select Service: cancelEvent', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  updateBlocks(eventId: number, blockCount: number): Promise<sEvent> {
    let promise = new Promise<sEvent>((resolve, reject) => {
      return this.http
        .post<sEvent>(
          this.apiHost +
            '/event/UpdateBlock?EventId=' +
            eventId +
            '&Blocked=' +
            blockCount.toString(),
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Select Service: updateBlocks', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  getTodaysEvents(group: number, venue: number): Promise<sEvent[]> {
    let promise = new Promise<sEvent[]>((resolve, reject) => {
      return this.http
        .get<sEvent[]>(
          this.apiHost +
            '/event/gettodaysevents?ServiceGroupId=' +
            group.toString() +
            '&ServiceVenueId=' +
            venue.toString()
        )
        .toPromise()
        .then(
          (data) => {
            data = data.sort((a, b) => {
              if (a.startTime < b.startTime) return -1;
              if (a.startTime > b.startTime) return 1;
              return 0;
            });
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Select Service: getTodaysEvent', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  getDatesForService()
  {
    let promise = new Promise<DateAvailability[]>((resolve, reject) => {
      return this.http
        .get<DateAvailability[]>(
          this.apiHost +
            '/event/getDatesForService'  
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Select Service: getDatesForService', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  getCalendarEvents(userId: string, group: number, venue: number, eventDate: string, hidden: boolean): Promise<sEvent[]> {
    const end = new Date(eventDate); end.setDate(end.getDate() + 90);
    const rangeEnd = `${end.getFullYear()}-${String(end.getMonth()+1).padStart(2,'0')}-${String(end.getDate()).padStart(2,'0')}T00:00:00`;
    return this.getEvents(userId, group, venue, eventDate, hidden, rangeEnd);
  }

  getEvents(
    userId: string,
    group: number,
    venue: number,
    eventDate: string,
    hidden: boolean, rangeEnd?: string
  ): Promise<sEvent[]> {
    let promise = new Promise<sEvent[]>((resolve, reject) => {
      return this.http
        .get<sEvent[]>(
          this.apiHost +
            '/event/getevents?UserId=' +
            userId +
            '&ServiceGroupId=' +
            group.toString() +
            '&ServiceVenueId=' +
            venue.toString() +
            '&EventDate=' +
            eventDate +
            '&Hidden=' +
            hidden.toString() + (rangeEnd ? '&RangeEnd=' + encodeURIComponent(rangeEnd) : '')
        )
        .toPromise()
        .then(
          (data) => {
            data = data.filter(a => a.singleRegistrationId == 0);
            data = data.sort((a, b) => {
              if (a.startTime < b.startTime) return -1;
              if (a.startTime > b.startTime) return 1;
              return 0;
            });
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Select Service: getEvents', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  getEvent(eventId: number): Promise<editEvent> {
    let promise = new Promise<editEvent>((resolve, reject) => {
      return this.http
        .get<editEvent>(
          this.apiHost + '/event/geteditevent?eventId=' + eventId.toString()
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Select Service: getEvent', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  saveEvent(event: editEvent, type: number): Promise<editEvent> {
    let promise = new Promise<editEvent>((resolve, reject) => {
      return this.http
        .post<editEvent>(
          this.apiHost + '/event/saveevent?Type=' + type.toString(),
          event
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Select Service: getEvent', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  GetDefaultValue(arr: any[]) {
    var el = arr.find((a) => a.default == true);
    var oth = arr.find((a) => a.flagged == false);
    if (el == null && oth == null) return 0;
    if (el == null) return oth.id;
    return el.id;
  }
}
